/**
 * The per-request cap every issue bulk route enforces
 * (packages/server/src/routes/issues/bulk.ts) and the copy each surface shows
 * when a selection exceeds it. 2026-10-14: select-all on a 140-issue project
 * sent one refused request and read "Invalid request body". Surfaces now block
 * Actions over the cap and offer "Select first 100" (Gmail's select-all banner,
 * inverted), so nobody has to count or unclick rows.
 */
export const BULK_MAX_IDS_PER_REQUEST = 100;
export const BULK_LIMIT_NOTICE = `You can act on up to ${BULK_MAX_IDS_PER_REQUEST} issues at a time.`;
export const BULK_SELECT_FIRST_LABEL = `Select first ${BULK_MAX_IDS_PER_REQUEST}`;
/** The server's 400 message for an over-cap request (older clients still send one). */
export const BULK_TOO_MANY_MESSAGE = `${BULK_LIMIT_NOTICE} Select fewer and try again.`;
/** The first `limit` selected ids in the table's current order. */
export function firstSelectedIds(orderedIds, selected, limit = BULK_MAX_IDS_PER_REQUEST) {
    const kept = [];
    for (const id of orderedIds) {
        if (kept.length >= limit)
            break;
        if (selected.has(id))
            kept.push(id);
    }
    return kept;
}
//# sourceMappingURL=bulkSelectionLimit.js.map